const supply = {
  intime: 21044075,
  ontime: 21042034,
  globaledu: 1000000000,
};

export default supply;
